import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export function EmptyState({
  icon,
  title,
  description,
  action,
  tone = "neutral",
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  tone?: "neutral" | "danger";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
        className,
      )}
    >
      {icon ? (
        <div
          className={cn(
            "rounded-full p-2",
            tone === "danger"
              ? "bg-danger-bg text-danger-fg"
              : "bg-neutral-800/60 text-neutral-400",
          )}
        >
          {icon}
        </div>
      ) : null}
      <div className="space-y-1">
        <h3
          className={cn(
            "text-sm font-medium",
            tone === "danger" ? "text-danger-fg" : "text-neutral-200",
          )}
        >
          {title}
        </h3>
        {description ? (
          <p className="max-w-md text-xs text-neutral-400">{description}</p>
        ) : null}
      </div>
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
